(() => {
  'use strict';

  if (window.__STRYKR_BELT_KACHING_ATC_20260605__) return;
  window.__STRYKR_BELT_KACHING_ATC_20260605__ = true;

  const ZONE_SELECTOR = '#strykr-commerce-zone[data-strykr-kaching-preselected-ok]';
  const BUTTON_SELECTOR = `${ZONE_SELECTOR} [data-strykr-kaching-atc], ${ZONE_SELECTOR} [id^="ProductSubmitButton-"]`;

  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const normalize = (value) => String(value || '').trim().toLowerCase();
  const parseJson = (value, fallback = null) => {
    try {
      return JSON.parse(value || 'null') || fallback;
    } catch (_) {
      return fallback;
    }
  };

  const getZone = () => document.querySelector(ZONE_SELECTOR);
  const getBlock = (zone) => zone && zone.querySelector('kaching-bundles-block');
  const getProduct = (zone) => {
    const block = getBlock(zone);
    const product = parseJson(block && block.getAttribute('product'), null);
    if (product) return product;

    const productId = block && (block.getAttribute('product-id') || parseJson(block.getAttribute('config'), {})?.productId);
    const script = productId
      ? document.querySelector(`script.kaching-bundles-product[data-product-id="${CSS.escape(String(productId))}"]`)
      : zone && zone.querySelector('script.kaching-bundles-product[data-product-id]');
    return parseJson(script && script.textContent, {}) || {};
  };
  const getDealBlock = (zone) => parseJson(getBlock(zone) && getBlock(zone).getAttribute('deal-block'), {}) || {};

  const getSelectedDeal = (zone) => {
    const dealBlock = getDealBlock(zone);
    const checked = zone && zone.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    const selectedId = checked && checked.value ? checked.value : dealBlock.preselectedDealBarId;
    if (!selectedId || !Array.isArray(dealBlock.dealBars)) return null;
    return dealBlock.dealBars.find((deal) => String(deal.id) === String(selectedId)) || null;
  };

  const getSelectedBar = (zone, selectedDeal) => {
    if (!zone) return null;
    const checked = zone.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    if (checked) {
      const checkedBar = checked.closest('.kaching-bundles__bar, [data-deal-bar-id]');
      if (checkedBar) return checkedBar;
    }

    const selectedId = selectedDeal && selectedDeal.id;
    if (!selectedId) return null;
    return zone.querySelector(`[data-deal-bar-id="${CSS.escape(String(selectedId))}"]`);
  };

  const getOptionValue = (node) => {
    if (!node) return '';
    if (node.tagName === 'SELECT') return String(node.value || node.dataset.value || '').trim();
    if (node.dataset && node.dataset.value) return String(node.dataset.value).trim();
    const selected = node.querySelector && node.querySelector('[aria-selected="true"], [data-selected="true"], option:checked');
    if (selected) return String(selected.value || selected.dataset.value || selected.textContent || '').trim();
    return String(node.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const getRowOptionSet = (row, optionNames) => {
    const byName = new Map();
    Array.from(row.querySelectorAll('.kaching-bundles-option[data-name]')).forEach((node) => {
      const name = node.dataset && node.dataset.name;
      if (!name) return;
      const value = getOptionValue(node);
      if (value) byName.set(normalize(name), value);
    });

    const ordered = optionNames.map((name) => byName.get(normalize(name)));
    return ordered.every(Boolean) ? ordered : [];
  };

  const getSelectedOptionSets = (zone, product, selectedDeal) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    const selectedBar = getSelectedBar(zone, selectedDeal);
    if (!selectedBar || !optionNames.length) return [];

    const rowSets = Array.from(selectedBar.querySelectorAll('.kaching-bundles__bar-variant'))
      .map((row) => getRowOptionSet(row, optionNames))
      .filter((options) => options.length === optionNames.length);
    if (rowSets.length) return rowSets;

    const optionCount = optionNames.length || 1;
    const controls = Array.from(selectedBar.querySelectorAll('.kaching-bundles-option[data-name], select.kaching-bundles-option, .kaching-bundles__bar-variant-select'));
    const sets = [];
    for (let index = 0; index < controls.length; index += optionCount) {
      const group = controls.slice(index, index + optionCount);
      if (group.length < optionCount) continue;
      const byName = new Map();
      group.forEach((node) => {
        const name = node.dataset && node.dataset.name;
        const value = getOptionValue(node);
        if (name && value) byName.set(normalize(name), value);
      });
      const ordered = optionNames.map((name) => byName.get(normalize(name)));
      if (ordered.every(Boolean)) sets.push(ordered);
    }
    return sets;
  };

  const findVariantByOptions = (product, selectedOptions) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find((variant) => {
      const options = Array.isArray(variant.options) ? variant.options : [];
      return selectedOptions.every((option, index) => normalize(options[index]) === normalize(option));
    }) || null;
  };

  const buildKachingProperties = (zone, selectedDeal) => {
    if (!selectedDeal || !selectedDeal.id) return null;
    const block = getBlock(zone);
    const dealBlock = getDealBlock(zone);
    const sessionId = (window.crypto && typeof window.crypto.randomUUID === 'function')
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    return {
      __kaching_bundles: JSON.stringify({
        deal: dealBlock.nanoId || dealBlock.id || (block && block.getAttribute('deal-block-id')) || '',
        main: true,
        bid: selectedDeal.id,
        ab: dealBlock.abTestVariantNumber === 2 ? 'B' : 'A'
      }),
      __kaching_session_id: sessionId
    };
  };

  const buildItems = () => {
    const zone = getZone();
    const product = getProduct(zone);
    const selectedDeal = getSelectedDeal(zone);
    const quantity = Number(selectedDeal && selectedDeal.quantity) || 1;
    const properties = quantity >= 2 ? buildKachingProperties(zone, selectedDeal) : null;
    const optionSets = getSelectedOptionSets(zone, product, selectedDeal).slice(0, quantity);

    const items = optionSets.map((selectedOptions) => {
      const variant = findVariantByOptions(product, selectedOptions);
      if (!variant || !variant.id) return null;
      const item = { id: Number(variant.id), quantity: 1 };
      if (properties) item.properties = properties;
      return item;
    }).filter(Boolean);

    if (items.length) return items;

    const input = zone && zone.querySelector('form[action*="/cart/add"] [name="id"], form[data-type="add-to-cart-form"] [name="id"]');
    const variantId = Number(input && input.value);
    if (!Number.isFinite(variantId) || variantId <= 0) {
      throw new Error('Variante Kaching introuvable pour le panier ceinture.');
    }
    const item = { id: variantId, quantity };
    if (properties) item.properties = properties;
    return [item];
  };

  const propertiesKey = (properties) => JSON.stringify(properties || {});
  const compactItems = (items) => {
    const compacted = [];
    items.forEach((item) => {
      const key = `${item.id}::${propertiesKey(item.properties)}::${item.selling_plan || ''}`;
      const existing = compacted.find((candidate) => candidate.__key === key);
      if (existing) {
        existing.quantity += Number(item.quantity) || 1;
        return;
      }
      compacted.push(Object.assign({ __key: key }, item));
    });
    return compacted.map(({ __key, ...item }) => item);
  };

  const addOne = async (item) => {
    const response = await fetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(item)
    });
    const text = await response.text();
    const json = text ? JSON.parse(text) : {};
    if (!response.ok) throw new Error(json.description || json.message || response.statusText);
    return json;
  };

  const addItems = async (items) => {
    const compacted = compactItems(items);
    const responses = [];
    for (const item of compacted) {
      responses.push(await addOne(item));
    }
    return {
      items: responses,
      sections: responses[responses.length - 1] && responses[responses.length - 1].sections
    };
  };

  const sectionUrl = (ids) => {
    const url = new URL(rootPath(), window.location.origin);
    url.searchParams.set('sections', ids.join(','));
    return url.toString();
  };

  const replaceSection = (id, html) => {
    if (!html) return;
    const nextDoc = new DOMParser().parseFromString(html, 'text/html');
    const next = nextDoc.getElementById(`shopify-section-${id}`) || nextDoc.getElementById(id);
    const current = document.getElementById(`shopify-section-${id}`) || document.getElementById(id);
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const refreshDrawer = async () => {
    try {
      const response = await fetch(sectionUrl(['cart-drawer', 'cart-icon-bubble']), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const sections = await response.json();
      replaceSection('cart-drawer', sections['cart-drawer']);
      replaceSection('cart-icon-bubble', sections['cart-icon-bubble']);
    } catch (_) {}
  };

  const updateCartCount = async () => {
    try {
      const cart = await fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-count').forEach((node) => {
        node.textContent = String(cart.item_count);
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
      return cart;
    } catch (_) {
      return null;
    }
  };

  const ensureDrawerElement = () => {
    if (typeof window.removeTrapFocus !== 'function') window.removeTrapFocus = () => {};
    if (typeof window.trapFocus !== 'function') window.trapFocus = () => {};
    if (!window.customElements || window.customElements.get('cart-drawer')) return;

    window.customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      open() {
        this.classList.add('active');
        this.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
  };

  const openDrawer = async () => {
    ensureDrawerElement();
    await refreshDrawer();
    ensureDrawerElement();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (drawer) {
      drawer.classList.add('active');
      drawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
    }
  };

  const setButtonState = (button, state) => {
    if (!button) return;
    const strings = (window.STRYKR_PRODUCT && window.STRYKR_PRODUCT.strings) || {};
    const label = button.querySelector('[data-cta-text], .main-atc__label__text, .button__label') || button;
    if (!button.dataset.defaultText) button.dataset.defaultText = label.textContent.trim() || strings.addToCart || 'In den Warenkorb';

    if (state === 'loading') {
      button.disabled = true;
      label.textContent = strings.adding || 'Wird hinzugefuegt...';
    } else if (state === 'added') {
      label.textContent = strings.added || 'Hinzugefuegt';
    } else if (state === 'error') {
      label.textContent = 'Fehler - erneut versuchen';
    } else {
      button.disabled = false;
      label.textContent = button.dataset.defaultText || strings.addToCart || 'In den Warenkorb';
    }
  };

  const handleAdd = async (button) => {
    if (!button || button.dataset.strykrBeltAdding === 'true') return;
    button.dataset.strykrBeltAdding = 'true';
    setButtonState(button, 'loading');

    try {
      const items = buildItems();
      const added = await addItems(items);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: added }));
      await updateCartCount();
      setButtonState(button, 'added');
      await openDrawer();
      window.setTimeout(() => {
        delete button.dataset.strykrBeltAdding;
        setButtonState(button, 'idle');
      }, 350);
    } catch (error) {
      console.warn('[STRYKR] Belt Kaching ATC failed', error);
      setButtonState(button, 'error');
      window.setTimeout(() => {
        delete button.dataset.strykrBeltAdding;
        setButtonState(button, 'idle');
      }, 1600);
    }
  };

  const shouldHandle = (button) => {
    const zone = getZone();
    if (!zone || !button || !zone.contains(button)) return false;
    const selectedDeal = getSelectedDeal(zone);
    return Boolean(selectedDeal && selectedDeal.id);
  };

  window.addEventListener('click', (event) => {
    const button = event.target && event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!shouldHandle(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handleAdd(button);
  }, true);

  window.addEventListener('submit', (event) => {
    const zone = getZone();
    const form = event.target && event.target.closest && event.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (!zone || !form || !zone.contains(form)) return;
    const button = form.querySelector(BUTTON_SELECTOR) || zone.querySelector(BUTTON_SELECTOR);
    if (!shouldHandle(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handleAdd(button);
  }, true);
})();
